import { z } from 'zod';

/**
 * An Item type maximum as it is typed. Checks only that it is filled in and above 0; the API checks
 * the decimal places and the upper limit, and its errors show on the field.
 */
export const itemTypeMaximumSchema = (label: string) => {
	return z.string()
		.trim()
		.min(1, `${label} is required`)
		// A blank value has already been told it is required.
		.refine((value) => value === '' || Number(value) > 0, `${label} must be above 0`);
}
